import { graphql } from 'gatsby'
import React from 'react'
import {
  SearchableFaq,
  SearchableFaqProps,
} from 'src/components/organisms/general/searchableFaq'
import { PrismicPageDataBodySearchableFaq } from 'src/typings/generated/graphql'
import { useFaqCategories } from 'src/utils/useFaqCategories'

/**
 * Props for the `SearchableFaqSlice` component.
 */
type Props = {
  slice: PrismicPageDataBodySearchableFaq
}

/**
 * Maps a Prismic slice of type `PrismicPageDataBodySearchableFaq` to the props required by the `SearchableFaq`
 * component and renders it.
 */
const SearchableFaqSlice = ({ slice }: Props) => {
  const faqCategories = useFaqCategories()

  const props: SearchableFaqProps = {
    anchor: slice.primary.anchor ?? undefined,
    headline: slice.primary.headline ?? undefined,
    categoryListTitle: slice.primary.category_list_title ?? undefined,
    categories: faqCategories,
    backButtonText: slice.primary.back_button_text ?? undefined,
    backButtonLink: slice.primary.back_button_link ?? undefined,
  }

  return <SearchableFaq {...props} />
}

export default SearchableFaqSlice

export const FaqFragment = graphql`
  fragment PageDataBodySearchableFaq on PrismicPageDataBodySearchableFaq {
    primary {
      anchor
      headline
      category_list_title
      back_button_text
      back_button_link {
        ...BasicLinkFragment
      }
    }
  }
`
